export default "__VITE_ASSET__D4DfjF5m__"